<section class="main-section">
  <div class="row">
    <div class="col">
      <div class="inner-box">
        <div class="row">
          <div class="col">
            <div class="invoice-title">
              <h2 class="ml-2">Shipping label</h2><h2 class="float-right">Order # 12345</h2>
            </div>
            <hr>
            <div class="row mt-2">
              <div class="col-md-6">
                <address class="ml-2">
                  <strong>Shipping To:</strong><br>
                  Buyer's Name<br>
                  Flat No.1, XYZ street<br>
                  India, Pin Code - XXXXX<br>
                </address>
              </div>
              <div class="col-md-6 text-right">
                <address>
                  <label><b>Courier :</b> Shift</label><br>
                  Barcode<br>
                  <label><b>Awb :</b> 4703900XXXX</label>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <address class="ml-2">
                  <label>Phone Num - 9887373XXX</label>
                </address>
              </div>
              <div class="col-md-6 text-right">
                <address>
                  <label><b>Routing Code :</b> ZKPZKP</label>
                </address>
              </div>
            </div>
            <div class="row shift-border-top">
              <div class="col-md-4 mt-3">
                <address class="ml-2">
                  <label>Dimensions - 15.0 X 19.0 x 9.0</label>
                </address>
              </div>
              <div class="col-md-4 mt-3">
                <address>
                  <label>Weight - 0.3 KG</label>
                </address>
              </div>
              <div class="col-md-4 mt-3">
                <address>
                  <label>COD AMOUNT : 3550.00 INR</label>
                </address>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <address class="ml-2">
                  <label>Payment : COD</label>
                </address>
              </div>
              <div class="col-md-4">
                <address class="shift-add-font">
                  <label>Items(s) : ABC Product</label>
                </address>
              </div>
              <div class="col-md-4"></div>
            </div>
            <div class="row shift-border-top">
              <div class="col-md-6 mt-3">
                <address class="ml-2">
                  <strong>Shipping By:</strong><br>
                  Snithik Technology<br>
                  Lanco Hills, Hyderabad<br>
                  Telangana, Pin Code - 2220xx<br><br>
                  Phone Num - 93245XXXX
                </address>
              </div>
              <div class="col-md-6 text-right mt-3">
                <address>
                  <label><b>Order # :</b> 6662444XX</label><br>
                  Barcode
                </address>
              </div>
            </div>
            <div class="shift-border-top"></div>
            <h6 class="mt-3"><label><b>Terms and Conditions</b></label></h6>
            <div class="row">
              <div class="col">
                <label>1.Visit official website of Shift to view the Condition of Carriage.</label><br>
                <label>2.Shipping charges are inclusive of service tax and all figure are in INR.</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-md-12 text-right">
      <button type="reset" class="btn btn-cancel">Cancel</button>
      <button type="submit" class="btn btn-orange ml-1">Print</button>
    </div>
  </div>
</section>

